var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",style:({ background: _vm.canvasBackground }),attrs:{"width":_vm.width,"height":_vm.height},on:{"pointerdown":_vm.startDrawing,"pointermove":_vm.continueDrawing,"pointerup":_vm.finishDrawing,"pointercancel":_vm.finishDrawing}})
}
var staticRenderFns = []

export { render, staticRenderFns }